import {configureStore} from '@reduxjs/toolkit';
import allCommentsReducer from './AllComments/allCommentsSlice';
import commentsCategoriesReducer from './CommentCategories/commentCategoriesSlice';
import commentMoodsReducer from './CommentMoods/commentMoodsSlice'
import commentTrendReducer from './CommentTrend/commentTrendSlice'
import filtersReducer from './filters/filtersSlice';

export const store = configureStore({
  reducer: {
    filters: filtersReducer,
    allComments: allCommentsReducer,
    commentCategories: commentsCategoriesReducer,
    commentMoods: commentMoodsReducer,
    commentTrend: commentTrendReducer,
  }
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
